module.exports = __webpack_public_path__ + "assets/img/a191-tk.svg";